import axios from 'axios';
import { toast } from 'react-toastify';
import {
  PROJECT_ON_BOARD_CREATE_FIELD_BEGIN,
  PROJECT_ON_BOARD_CREATE_FIELD_SUCCESS,
  PROJECT_ON_BOARD_CREATE_FIELD_FAILURE,
  PROJECT_ON_BOARD_CREATE_FIELD_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function createField(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_CREATE_FIELD_BEGIN,
    });
    const { projectId, version, collection } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${collection.collectionName}/fields`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: PROJECT_ON_BOARD_CREATE_FIELD_SUCCESS,
              data: res.data,
              collection: args.collection,
            });
            toast.success('Created Field Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: PROJECT_ON_BOARD_CREATE_FIELD_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_CREATE_FIELD_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateFieldError() {
  return {
    type: PROJECT_ON_BOARD_CREATE_FIELD_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_CREATE_FIELD_BEGIN:
      return {
        ...state,
        createFieldPending: true,
        createFieldError: null,
      };

    case PROJECT_ON_BOARD_CREATE_FIELD_SUCCESS:
      const currentFields = action.collection.fields || [];
      currentFields.push(action.data);
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.collectionName === action.collection.collectionName;
      });
      projectCollections[index].fields = currentFields;
      return {
        ...state,
        createFieldPending: false,
        createFieldError: null,
        projectCollections,
      };

    case PROJECT_ON_BOARD_CREATE_FIELD_FAILURE:
      return {
        ...state,
        createFieldPending: false,
        createFieldError: action.data.error,
      };

    case PROJECT_ON_BOARD_CREATE_FIELD_DISMISS_ERROR:
      return {
        ...state,
        createFieldError: null,
      };

    default:
      return state;
  }
}
